import { Link } from "react-router-dom";
import { Footer } from "./layout/Footer";
import Navbar from "./layout/Navbar";

const NotFound = () => {
  return (
    <>
      <Navbar />
      <div className="flex flex-col min-h-[calc-(100vh-200px)] justify-center items-center">
        <img className="w-[350px] " src="/assets/404.png" alt="404" />
        <h1 className="lg:text-6xl -mt-10 md:text-4xl text-3xl my-3 font-bold font-kanit">
          Page Not Found
        </h1>
        <p className="font-medium text-">
          If you look harder, you'd find what you are searching for.
        </p>
        <Link className="font-medium text-purple-600" to="/">
          Go to Home
        </Link>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
